import { PageHero, CTASection } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";
import { Counter } from "@/components/Counter";
import { TIMELINE, IMAGES, STATS } from "@/lib/data";

export default function About() {
  return (
    <div>
      <PageHero index="01 — About Us" title={<>A Family Legacy<br />in Precision.</>} subtitle="More than five decades of pattern-making, carried forward across three generations." image={IMAGES.woodShelf} />

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-2xl md:text-3xl font-display font-medium tracking-tight leading-snug text-[#0E1626]">
              JM Mevada Pattern Works is a family-owned industrial pattern manufacturing and engineering company with more than 55 years of experience in the pattern-making and manufacturing industry.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-lg text-slate-600 font-light leading-relaxed">
              The business was originally established by <span className="text-[#0E1626] font-medium">Mr. Jagjivanbhai Mevada</span> under the name JM Mevada & Co., and was later continued by <span className="text-[#0E1626] font-medium">Mr. Dilipbhai Mevada</span>. Over the years, the company has successfully manufactured 72,000+ industrial patterns and has built a reputation based on quality, precision, competitive pricing and on-time delivery.
            </p>
            <p className="mt-5 text-lg text-slate-600 font-light leading-relaxed">
              We work in the industrial manufacturing and sourcing sector and provide reliable manufacturing support for industrial customers — treating every pattern as a long-term commitment to our partners.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <img src={IMAGES.woodShelf} alt="Wooden patterns" className="w-full h-[380px] object-cover border border-[#DCE1E8]" />
          </Reveal>
          <div className="grid grid-cols-2 mt-6 border-l border-t border-[#DCE1E8]">
            {STATS.map((s, i) => (
              <div key={i} className="border-r border-b border-[#DCE1E8] bg-white p-6">
                <div className="font-display font-extrabold text-3xl text-[#0E1626]"><Counter to={s.value} suffix={s.suffix} /></div>
                <div className="font-mono text-[10px] tracking-widest uppercase text-slate-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-[#DCE1E8] bg-white">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32">
          <div className="overline mb-4">The Timeline</div>
          <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl mb-16 text-[#0E1626]">Company Growth & Generations</h2>
          <div className="relative">
            {TIMELINE.map((t, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="grid md:grid-cols-12 gap-6 py-10 border-t border-[#DCE1E8] group" data-testid={`timeline-${i}`}>
                  <div className="md:col-span-3 font-display font-extrabold text-4xl md:text-5xl text-[#1D4ED8]">{t.year}</div>
                  <div className="md:col-span-4 font-display font-bold text-2xl tracking-tight text-[#0E1626]">{t.title}</div>
                  <div className="md:col-span-5 text-slate-600 font-light leading-relaxed">{t.desc}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32 grid md:grid-cols-2 gap-12">
        <Reveal>
          <div className="border border-[#DCE1E8] bg-white p-10 h-full">
            <div className="overline mb-4">Manufacturing Philosophy</div>
            <p className="text-lg text-slate-700 font-light leading-relaxed">Precision is not negotiable. Every pattern, die and tool is built to the customer's exact drawings and dimensions, using the right material and method for the job. Our focus is patterns, dies, tooling, CNC machining and custom engineering work.</p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border border-[#DCE1E8] bg-white p-10 h-full">
            <div className="overline mb-4">Customer Commitment</div>
            <p className="text-lg text-slate-700 font-light leading-relaxed">We aim to be a long-term manufacturing partner — competitive pricing, on-time delivery, and reliable support for repeat and custom requirements alike.</p>
          </div>
        </Reveal>
      </section>

      <CTASection />
    </div>
  );
}
